import React from 'react';
import ReactEmoji from 'react-emoji';
import MicrolinkCard from 'react-microlink'
import { connect } from 'react-redux';

import styles from './MessageCard.css';


const mapStateToProps = state => {
  return { theme: state.user.theme };
};

const ConnectedMessageCard = (props) => {

  let myMessagesTheme, otherMessagesTheme = '';
  if (props.theme === 'DARK') {
    myMessagesTheme = styles.myMessageDarkTheme;
    otherMessagesTheme = styles.otherMessageDarkTheme;
  }

  return <div className={styles.mainContainer}>
    {props.isMine ?
      <div className={[styles.myMessage, myMessagesTheme].join(' ')}>
        {props.isUrl && <MicrolinkCard url={props.url} />}
        <span>{ReactEmoji.emojify(props.message)}</span>
      </div>
      :
      <div className={[styles.otherMessage, otherMessagesTheme].join(' ')}>
        {props.isUrl && <MicrolinkCard url={props.url} />}
        <span>{ReactEmoji.emojify(props.message)}</span>
      </div>
    }
  </div>
}

const MessageCard = connect(mapStateToProps)(ConnectedMessageCard);

export default MessageCard;



// WEBPACK FOOTER //
// ./src/pages/chat/chat-messages/message-history/message-card/MessageCard.jsx